export const Logo = () => {return (

      <div className="logo">
        <img src='/eln-london.png' width='200' height='97' alt="EL&amp;N London" />
            <h1>BUSINESS 2 BUSINESS</h1>
          </div>)}